module.exports = __webpack_public_path__ + "fonts/DM_Sans-600-latin13.3ccd9ab.woff2";